// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Editor} from '../../../shared/editor/editor';
import {Settings_context} from '../settings_ctx';
import styles from './stop_losing_banner.module.less';
import cn from 'classnames';

const Stopwatch = ()=>{
    return <svg width="48" height="48" viewBox="0 0 48 48" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M39.5 27C39.5 18.4396 32.5604 11.5 24 11.5C15.4396 11.5 8.5
        18.4396 8.5 27C8.5 35.5604 15.4396 42.5 24 42.5C32.5604 42.5 39.5
        35.5604 39.5 27ZM22.5 19C22.5 18.1716 23.1716 17.5 24 17.5C24.8284
        17.5 25.5 18.1716 25.5 19V26.1484L29.7715 28.7129C30.4817 29.139
        30.7129 30.0612 30.2871 30.7715C29.861 31.4817 28.9388 31.7129
        28.2285 31.2871L23.2285 28.2871C22.7767 28.016 22.5 27.5269 22.5
        27V19ZM9.28125 7.12305C9.86692 6.5375 10.8166 6.53767 11.4023
        7.12305C11.9881 7.70879 11.988 8.65834 11.4023 9.24414L8.40234
        12.2441C7.81656 12.8299 6.86704 12.8299 6.28125 12.2441C5.69583
        11.6583 5.69559 10.7087 6.28125 10.123L9.28125 7.12305ZM36.5977
        7.12305C37.1469 6.57422 38.0164 6.5391 38.6055 7.01953L38.7188
        7.12305L41.7188 10.123C42.3044 10.7087 42.3042 11.6583 41.7188
        12.2441C41.133 12.8299 40.1834 12.8299 39.5977 12.2441L36.5977
        9.24414C36.012 8.65834 36.0119 7.70879 36.5977 7.12305ZM42.5
        27C42.5 37.2173 34.2173 45.5 24 45.5C13.7827 45.5 5.5 37.2173
        5.5 27C5.5 17.2878 12.9844 9.32816 22.5 8.56445V5.5H20C19.1716
        5.5 18.5 4.82843 18.5 4C18.5 3.17157 19.1716 2.5 20 2.5H28C28.8284
        2.5 29.5 3.17157 29.5 4C29.5 4.82843 28.8284 5.5 28
        5.5H25.5V8.56445C35.0156 9.32816 42.5 17.2878 42.5 27Z"
        fill="url(#paint0_linear_107_5835)"/>
      <defs>
      <linearGradient id="paint0_linear_107_5835" x1="24" y1="2.5" x2="24"
        y2="45.5" gradientUnits="userSpaceOnUse">
      <stop stop-color="#71BBFF"/>
      <stop offset="1" stop-color="#FFB9F8"/>
      </linearGradient>
      </defs>
    </svg>;
};

const Connection = ()=>{
    return <svg width="48" height="48" viewBox="0 0 48 48" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M34.9395 12.9393C35.5252 12.3536 36.4748 12.3536 37.0605
        12.9393L45.0605 20.9393C45.6463 21.5251 45.6463 22.4746 45.0605
        23.0604L37.0605 31.0604C36.4748 31.6462 35.5252 31.6462 34.9395
        31.0604C34.3537 30.4746 34.3537 29.5251 34.9395 28.9393L40.3789
        23.4998H31.1387C29.168 23.4998 28.4931 23.5146 27.9043
        23.6932C27.3383 23.8651 26.8105 24.1477 26.3535 24.5233C25.8815
        24.9113 25.4971 25.4578 24.4219 27.0702L20.1484 34.4745C20.1324
        34.5023 20.1155 34.5297 20.0977 34.5565C19.1075 36.0417 18.4518
        37.0542 17.5508 37.7948C16.7894 38.4204 15.9117 38.8892 14.9688
        39.1756C13.8528 39.5145 12.6464 39.4998 10.8613 39.4998H6C5.17157
        39.4998 4.5 38.8283 4.5 37.9998C4.50004 37.1715 5.17159 36.4998 6
        36.4998H10.8613C12.8321 36.4998 13.5069 36.4851 14.0957
        36.3065C14.6617 36.1346 15.1895 35.852 15.6465 35.4764C16.1186
        35.0884 16.5007 34.5403 17.5762 32.9276L21.8516 25.5252L21.9023
        25.4432C22.8925 23.958 23.5482 22.9455 24.4492 22.2049C25.2106
        21.5793 26.0883 21.1105 27.0312 20.8241C28.1472 20.4852 29.3537
        20.4998 31.1387 20.4998H40.3789L34.9395 15.0604C34.3537 14.4746
        34.3537 13.5251 34.9395 12.9393Z" fill="url(#paint0_linear_107_5840)"/>
      <path d="M10.8613 8.49985C12.6463 8.49985 13.8528 8.48516 14.9688
        8.82407C15.9117 9.11051 16.7894 9.57926 17.5508 10.2049C18.4518
        10.9455 19.1075 11.958 20.0977 13.4432L20.498 14.0428C20.6613
        14.0153 20.8289 13.9998 21 13.9998C22.6568 13.9998 24 15.343 24
        16.9998C24 18.6567 22.6569 19.9998 21 19.9998C19.3431 19.9998 18
        18.6567 18 16.9998C18 16.6358 18.0668 16.2875 18.1855 15.9647C18.1504
        15.9227 18.117 15.8785 18.0859 15.8319L17.6016 15.1073C16.5079
        13.4668 16.122 12.9142 15.6465 12.5233C15.1895 12.1477 14.6617
        11.8651 14.0957 11.6932C13.5069 11.5146 12.832 11.4998 10.8613
        11.4998H6C5.17157 11.4998 4.5 10.8283 4.5 9.99985C4.50004 9.17145
        5.17159 8.49985 6 8.49985H10.8613Z"
        fill="url(#paint1_linear_107_5840)"/>
      <defs>
      <linearGradient id="paint0_linear_107_5840" x1="24.9999" y1="8.49976"
        x2="24.9999" y2="39.4999" gradientUnits="userSpaceOnUse">
      <stop stop-color="#71BBFF"/>
      <stop offset="1" stop-color="#FFB9F8"/>
      </linearGradient>
      <linearGradient id="paint1_linear_107_5840" x1="24.9999" y1="8.49976"
        x2="24.9999" y2="39.4999" gradientUnits="userSpaceOnUse">
      <stop stop-color="#71BBFF"/>
      <stop offset="1" stop-color="#FFB9F8"/>
      </linearGradient>
      </defs>
    </svg>;
};

const Lightning = ()=>{
    return <svg width="48" height="48" viewBox="0 0 48 48" fill="none"
    xmlns="http://www.w3.org/2000/svg">
      <path d="M28.9159 2.46294C29.3779 1.98012 30.1032 1.86199 30.6952
        2.17192C31.2874 2.48211 31.6028 3.14594 31.4687 3.80083L28.7265
        17.1778L39.5155 21.127C39.9906 21.3009 40.3461 21.7027 40.4609
        22.1954C40.5755 22.6883 40.4337 23.2065 40.0839 23.5723L19.0839
        45.5372C18.622 46.02 17.8966 46.1381 17.3046 45.8282C16.7124 45.518
        16.3971 44.8542 16.5312 44.1993L19.2714 30.8204L8.4843 26.8731C8.00924
        26.6992 7.65377 26.2974 7.53898 25.8047C7.42436 25.3118 7.56618 24.7936
        7.91594 24.4278L28.9159 2.46294ZM11.6659 24.8438L21.5155
        28.4493C22.2127 28.7046 22.6177 29.4309 22.4687 30.1583L20.5136
        39.6993L36.332 23.1543L26.4843 19.5508C25.7871 19.2955 25.3822
        18.5692 25.5312 17.8418L27.4843 8.29888L11.6659 24.8438Z"
        fill="url(#paint0_linear_107_5845)"/>
      <defs>
      <linearGradient id="paint0_linear_107_5845" x1="23.9999" y1="2.00049"
        x2="23.9999" y2="45.9996" gradientUnits="userSpaceOnUse">
      <stop stop-color="#71BBFF"/>
      <stop offset="1" stop-color="#FFB9F8"/>
      </linearGradient>
      </defs>
    </svg>;
};

const cards = [
    {
        icon: Stopwatch,
        title: 'Lower Your Ping',
        desc: 'Route your data through the fastest network paths to'
            +' minimize latency.'
    },
    {
        icon: Connection,
        title: 'Stabilize Your Connection',
        desc: 'Eliminates unstable routes that cause packet loss and'
            +' random disconnects.'
    },
    {
        icon: Lightning,
        title: 'Start Instantly',
        desc: 'Install and optimize your favorite games with a single'
            +' click\u2014no manual setup required.'
    },
];

interface i_stop_losing_banner_props {
    title: string;
}

export const Stop_losing_banner = (props: i_stop_losing_banner_props)=>{
    const {title} = props;
    const {theme} = useContext(Settings_context);
    return <div className={theme.stop_losing_banner}>
      <h2 className={styles.header}>{title}</h2>
      <div className={styles.cards}>
        {cards.map(c=>
          <div key={c.title} className={styles.card}>
            <c.icon />
            <div className={styles.card_text}>
              <p className={cn([theme.u2, theme.color_n700])}>{c.title}</p>
              <p className={cn([theme.p2, theme.color_n600])}>{c.desc}</p>
            </div>
          </div>
        )}
      </div>
    </div>;
};

interface i_stop_losing_banner_editor_props {
    value: i_stop_losing_banner_props;
    on_change: (new_val: i_stop_losing_banner_props)=>void;
}

export const Stop_losing_banner_editor = (
{value, on_change}: i_stop_losing_banner_editor_props)=>{
    return <Editor value={value} on_change={on_change}
      editors={[
        {key: 'title', label: 'Title (h2)', type: 'text'},
      ]}/>;
};
